const enum PostTypes {
  ARTICLE = 'ARTICLE',
  SEARCH = 'SEARCH',
}

export default PostTypes;
